import { render, staticRenderFns } from "./registrationCertificate.vue?vue&type=template&id=7324337f&scoped=true"
import script from "./registrationCertificate.vue?vue&type=script&lang=js"
export * from "./registrationCertificate.vue?vue&type=script&lang=js"
import style0 from "./registrationCertificate.vue?vue&type=style&index=0&id=7324337f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7324337f",
  null
  
)

export default component.exports